import { Company, Group } from '@esg/esg-global-types';
import { createContext } from 'react';
import { CompanyExtended } from '../lib/app/company';

interface ContextProps {
  company: Company | null;
  handleCompanyChange: (company: Company | null) => void;
  addGroupCompany: (new_company: CompanyExtended) => void;
  removeGroupCompany: (deleted_company: Company) => void;
  removeGroup: (deleted_group: Group) => void;
}

export const CompanyContext = createContext<ContextProps>({
  company: null,
  handleCompanyChange: () => null,
  addGroupCompany: () => null,
  removeGroupCompany: () => null,
  removeGroup: () => null
});
